import React from 'react';
import ReactDOM from 'react-dom';

interface Props {
  handleClose: () => void;
  show: boolean;
  children: React.ReactNode;
}

const Modal = ({ handleClose, show, children }: Props) => {
  if (!show) return null;

  return ReactDOM.createPortal(
    <div className={show ? 'modal display-block' : 'modal display-none'}>
      <section className="modal-main">
        <div className="modal-content">{children}</div>
        <button type="button" className="absolute top-[24px] right-[24px]" onClick={handleClose}>
          <i className="fa-solid fa-xmark fa-xl text-main" />
        </button>
      </section>
    </div>,
    document.getElementById('root') as Element,
  );
};

export default Modal;
